import { defineMessages } from 'react-intl';

export default defineMessages({
    claimInformation: {
        id: 'twia.fnol.common.views.fnol.Claim Information',
        defaultMessage: 'Claim Information',
    },
    selectPolcicy: {
        id: 'twia.fnol.wizard.steps.Select Policy',
        defaultMessage: 'Select a Policy',
    },
    additionalInformation: {
        id: 'twia.fnol.wizard.steps.Additional Information',
        defaultMessage: 'Additional Information',
    },
    searchCriteria: {
        id: 'twia.fnol.common.views.policy-select-policyholder.No policies were found that match the search criteria.',
        defaultMessage:
            'No policies were found that match the search criteria.',
    },
    selectPolicy: {
        id: 'twia.fnol.common.views.policy-select-policyholder.Select A Policy',
        defaultMessage: 'Select a Policy',
    },
    lossInformation: {
        id: 'twia.fnol.common.views.policy-select-policyholder.Loss Information',
        defaultMessage: 'Loss Information {policyNumber}',
    },
    searchingPolicies: {
        id: 'twia.fnol.common.views.policy-select-policyholder.Searching for your policies...',
        defaultMessage: 'Searching for your policies...',
    },
    policyNotFoundMessage: {
        id: 'twia.fnol.common.views.policy-select-producer.No policies were found that match the search criteria.',
        defaultMessage:
            'No policies were found that match the search criteria.',
    },
    whenDidTheLossOccur: {
        id: 'twia.fnol.common.directives.loss-date-input.When did the loss occur?',
        defaultMessage: 'When did the loss occur?',
    },
    fnolSummaryHeader: {
        id: 'twia.fnol.wizard.step.Summary',
        defaultMessage: 'Summary',
    },
    fnolReviewInformation: {
        id: 'twia.fnol.common.views.summary.Please review the following information before submitting:',
        defaultMessage:
            'Please review the following information before submitting:',
    },
    fnolPolicyNumber: {
        id: 'twia.fnol.common.views.summary.Policy Number',
        defaultMessage: 'Policy Number',
    },
    fnolTypeOfIncident: {
        id: 'twia.fnol.common.views.summary.Type of Incident',
        defaultMessage: 'Type of Incident',
    },
    fnolCauseofDamageorloss: {
        id: 'twia.fnol.common.views.summary.Cause of Damage or loss',
        defaultMessage: 'Cause of Damage or Loss',
    },
    fnolSummaryWhen: {
        id: 'twia.fnol.common.views.summary.When?',
        defaultMessage: 'When?',
    },
    fnolSummaryWhere: {
        id: 'twia.fnol.common.views.summary.Where?',
        defaultMessage: 'Where?',
    },
    fnolSummaryContactPerson: {
        id: 'twia.fnol.common.views.summary.Contact Person',
        defaultMessage: 'Contact Person',
    },
    fnolRepairFacility: {
        id: 'twia.fnol.common.views.summary.Repair Facility',
        defaultMessage: 'Repair Facility',
    },
    fnolNoRepairRequested: {
        id: 'twia.fnol.common.views.summary.No repair requested',
        defaultMessage: 'No repair requested',
    },
    fnolNoteToAdjuter: {
        id: 'twia.fnol.common.views.summary.Message to TWIA',
        defaultMessage: 'Message to TWIA',
    },
    fnolNoteToAdjuterTFPA: {
        id: 'twia.fnol.common.views.summary.Message to TFPA',
        defaultMessage: 'Message to TFPA',
    },
    fnolEdit: {
        id: 'twia.fnol.common.views.summary.Edit',
        defaultMessage: 'Edit',
    },
    fnolDelete: {
        id: 'twia.fnol.common.views.summary.Delete',
        defaultMessage: 'Delete',
    },
    fnolAddNoteToAdjuster: {
        id: 'twia.fnol.common.views.summary.Add a Note to the Adjuster',
        defaultMessage: 'Send Message to TWIA',
    },
    fnolAddNoteToAdjusterTFPA: {
        id: 'twia.fnol.common.views.summary.Add a Note to the AdjusterTFPA',
        defaultMessage: 'Send Message to TFPA',
    },
    fnolSummaryPara: {
        id: 'twia.fnol.common.views.summary.This represents where a carrier might put the text surrounding their Fraud statement. This text is illustrative and should be updated accordingly.',
        defaultMessage:
            'TWIA takes insurance fraud seriously. By submitting this claim, you are certifying that all information is true and correct to the best of your knowledge. Knowingly presenting false or fraudulent claims is a violation of Texas state law.',
    },
    fnolSummaryParaTFPA: {
        id: 'tfpa.fnol.common.views.summary.This represents where a carrier might put the text surrounding their Fraud statement. This text is illustrative and should be updated accordingly.',
        defaultMessage:
            'TFPA takes insurance fraud seriously. By submitting this claim, you are certifying that all information is true and correct to the best of your knowledge. Knowingly presenting false or fraudulent claims is a violation of Texas state law.',
    },
    dialogAddNoteToAdjuster: {
        id: 'twia.fnol.common.views.note-dialog.Add a Note to the Adjuster',
        defaultMessage: 'Message to TWIA',
    },
    dialogAddNoteToAdjusterTFPA: {
        id: 'twia.fnol.common.views.note-dialog.Add a Note to the AdjusterTFPA',
        defaultMessage: 'Message to TFPA',
    },
    dialogSubject: {
        id: 'twia.fnol.common.views.note-dialog.Subject',
        defaultMessage: 'Subject',
    },
    dialogNote: {
        id: 'twia.fnol.common.views.note-dialog.Body',
        defaultMessage: 'Body',
    },
    dialogCancel: {
        id: 'twia.fnol.common.views.note-dialog.Cancel',
        defaultMessage: 'Cancel',
    },
    dialogOk: {
        id: 'twia.fnol.common.views.note-dialog.OK',
        defaultMessage: 'Ok',
    },
    primaryContactDetails: {
        id: 'twia.fnol.common.views.main-contact.Primary Contact Details',
        defaultMessage: 'Primary Contact Details',
    },
    verifyContactInformation: {
        id: 'twia.fnol.common.views.main-contact.Verify the contact information with the client. They may have changed address recently or would prefer to use another address for claim correspondence.',
        defaultMessage:
            'Verify the contact information with the client. They may have changed address recently or would prefer to use another address for claim correspondence.',
    },
    contactDetailsWizardStep: {
        id: 'twia.fnol.wizard.step.Contact Details',
        defaultMessage: 'Contact Details',
    },
    commonContactHeader: {
        id: 'twia.fnol.common.views.main-contact.Contact',
        defaultMessage: 'Contact',
    },
    commonContactEmailHeader: {
        id: 'twia.fnol.common.views.main-contact.Email',
        defaultMessage: 'Email',
    },
    wizardTitleAdditionalInformation: {
        id: 'twia.fnol.wizard.step.Additional Information',
        defaultMessage: 'Additional Information',
    },
    fnolSupportingInformation: {
        id: 'twia.fnol.common.views.more-info.Supporting Information',
        defaultMessage: 'Supporting Information',
    },
    fnolAddMoreInfo: {
        id: 'twia.fnol.common.views.more-info.Add photos or documents that are relevant to the incident and may help with the claim.',
        defaultMessage:
            'Add photos or documents that are relevant to the incident and may help with the claim.',
    },
    fnolWitnessesOtherParties: {
        id: 'twia.fnol.common.views.more-info.Witnesses or Other Parties',
        defaultMessage: 'Witnesses or Other Parties',
    },
    fnolAddPerson: {
        id: 'twia.fnol.common.views.more-info.Add Another Person',
        defaultMessage: 'Add Another Person',
    },
    fnolAnotherPerson: {
        id: 'twia.fnol.common.views.more-info.Another person',
        defaultMessage: 'Another person',
    },
    fnolFirstName: {
        id: 'twia.fnol.common.views.more-info.First name',
        defaultMessage: 'First Name',
    },
    fnolLastName: {
        id: 'twia.fnol.common.views.more-info.Last name',
        defaultMessage: 'Last Name',
    },
    fnolInvolvement: {
        id: 'twia.fnol.common.views.more-info.Involvement',
        defaultMessage: 'Involvement',
    },
    fnolPhoneNumber: {
        id: 'twia.fnol.common.views.more-info.Phone number',
        defaultMessage: 'Phone number',
    },
    fnolInjured: {
        id: 'twia.fnol.common.views.more-info.Injured',
        defaultMessage: 'Injured',
    },
    fnolRemoveUploadedDocument: {
        id: 'twia.platform.widgets.fileupload.templates.Are you sure you want to remove:',
        defaultMessage: 'Are you sure you want to remove: {documentName}?',
    },
    fnolRemove: {
        id: 'twia.fnol.common.views.more-info.Remove',
        defaultMessage: 'Remove',
    },
    fnolYes: {
        id: 'twia.fnol.common.controllers.MoreInfoCtrl.Yes',
        defaultMessage: 'Yes',
    },
    fnolNo: {
        id: 'twia.fnol.common.controllers.MoreInfoCtrl.No',
        defaultMessage: 'No',
    },
    otherPerson: {
        id: 'twia.fnol.common.controllers.MainContactCtrl.Other Person',
        defaultMessage: 'Other Person',
    },
    newContact: {
        id: 'twia.fnol.common.controllers.MainContactCtrl.New Contact',
        defaultMessage: 'New Contact',
    },
    fnolDetailedPolicyNumber: {
        id: 'twia.fnol.common.directives.policy-search-result-detailed.Policy Number',
        defaultMessage: 'Policy Number',
    },
    fnolDetailedInsured: {
        id: 'twia.fnol.common.directives.policy-search-result-detailed.Insured',
        defaultMessage: 'Insured',
    },
    fnolDetailedAddress: {
        id: 'twia.fnol.common.directives.policy-search-result-detailed.Address',
        defaultMessage: 'Address',
    },
    fnolDetailedType: {
        id: 'twia.fnol.common.directives.policy-search-result-detailed.Type',
        defaultMessage: 'Type',
    },
    fnolDetailedEffective: {
        id: 'twia.fnol.common.directives.policy-search-result-detailed.Effective',
        defaultMessage: 'Effective',
    },
    fnolDetailedExpires: {
        id: 'twia.fnol.common.directives.policy-search-result-detailed.Expires',
        defaultMessage: 'Expires',
    },
    successfullySubmitted: {
        id: 'twia.fnol.common.views.confirmation.Claim was successfully submitted',
        defaultMessage: 'Claim was successfully submitted',
    },
    confirmationThankMessage: {
        id: 'twia.fnol.common.views.confirmation.Thank you for submitting a claim. Our Adjustment team will be in contact shortly.',
        defaultMessage:
            'Thank you for submitting a claim. Our Adjustment team will be in contact shortly.',
    },
    referenceNumber: {
        id: 'twia.fnol.common.views.confirmation.Your claim number is:',
        defaultMessage: 'Your claim number is: { num }',
    },
    foundationInsurance: {
        id: 'twia.fnol.common.views.confirmation.Kind regards, Foundation Insurance',
        defaultMessage: 'Kind regards, Foundation Insurance',
    },
    printConfirmation: {
        id: 'twia.fnol.common.views.confirmation.Print Confirmation',
        defaultMessage: 'Print Confirmation',
    },
    fnolSaveandExit: {
        id: 'twia.fnol.wizard.Save and Exit',
        defaultMessage: 'Save and Exit',
    },
    fnolSubmitClaim: {
        id: 'twia.fnol.common.views.summary.Submit My Claim Now',
        defaultMessage: 'Submit Claim',
    },
    fnolSubmitClaimShort: {
        id: 'twia.fnol.common.views.summary.Submit',
        defaultMessage: 'Submit',
    },
    fnolNoteErrorHead: {
        id: 'twia.fnol.common.controllers.SummaryCtrl.Note Error Head',
        defaultMessage: 'Note submission failed',
    },
    fnolNoteErrorMessage: {
        id: 'twia.fnol.common.controllers.SummaryCtrl.Note Error Message',
        defaultMessage: 'Note cannot be processed at this time. ',
    },
    fnolSubmitClaimDetails: {
        id: 'twia.fnol.common.config.FlowConfig.Submitting claim details...',
        defaultMessage: 'Submitting claim details...',
    },
    fnolErrorSubmitClaimTitle: {
        id: 'twia.fnol.common.config.FlowConfig.Error submitting claim',
        defaultMessage: 'Error submitting claim',
    },
    fnolErrorSubmitClaimMessage: {
        id: 'twia.fnol.common.config.FlowConfig.An error occurred attempting to submit the claim.',
        defaultMessage: 'An error occurred attempting to submit the claim.',
    },
    fnolSaveDraftErrorTitle: {
        id: 'twia.fnol.common.config.FlowConfig.Unable to save draft claim information',
        defaultMessage: 'Unable to save draft claim information',
    },
    fnolSaveDraftErrorMessage: {
        id: 'twia.fnol.common.config.FlowConfig.An error occurred while attempting to save the claim submission.',
        defaultMessage:
            'An error occurred while attempting to save the claim submission.',
    },
    fnolSaveDraftClaim: {
        id: 'twia.fnol.common.config.FlowConfig.Saving draft claim details...',
        defaultMessage: 'Saving draft claim details...',
    },
    generalCreateDraftErrorTitle: {
        id: 'twia.fnol.general.config.FlowConfig.Error creating claim',
        defaultMessage: 'Error creating claim',
    },
    generalCreateDraftErrorMessage: {
        id: 'twia.fnol.general.config.FlowConfig.An error occurred attempting to create a claim.',
        defaultMessage: 'An error occurred attempting to create a claim.',
    },
    generalCreateDraftClaim: {
        id: 'twia.fnol.general.config.FlowConfig.Creating draft claim...',
        defaultMessage: 'Creating draft claim...',
    },
    wizardTypeOfIncident: {
        id: 'twia.fnol.wizard.step.general.Type of Incident',
        defaultMessage: 'Type of Incident',
    },
    generalWizardTypeOfIncident: {
        id: 'twia.fnol.wizard.step.general.Type of Incident',
        defaultMessage: 'Type of Incident',
    },
    wizardTitleWhere: {
        id: 'twia.fnol.wizard.step.general.Where',
        defaultMessage: 'Where',
    },
    generalWasAnyoneInjured: {
        id: 'twia.fnol.general.views.what.Was anyone injured?',
        defaultMessage: 'Was anyone injured?',
    },
    generalAddAnInjured: {
        id: 'twia.fnol.general.views.what.Add an injured...',
        defaultMessage: 'Add an injured...',
    },
    generalFirstName: {
        id: 'twia.fnol.general.views.what.First Name',
        defaultMessage: 'First Name',
    },
    generalLastName: {
        id: 'twia.fnol.general.views.what.Last Name',
        defaultMessage: 'Last Name',
    },
    generalFirstNameKanji: {
        id: 'twia.fnol.general.views.what.First Name Kanji',
        defaultMessage: 'First Name Kanji',
    },
    generalLastNameKanji: {
        id: 'twia.fnol.general.views.what.Last Name Kanji',
        defaultMessage: 'Last Name Kanji',
    },
    generalInjuryDescription: {
        id: 'twia.fnol.general.views.what.Description',
        defaultMessage: 'Description',
    },
    generalInjured: {
        id: 'twia.fnol.general.views.what.Injured',
        defaultMessage: 'Injured #{injuredIndex}',
    },
    generalRemoveInjuredPopupTitle: {
        id: 'twia.fnol.general.views.what.modal.Remove Injured',
        defaultMessage: 'Remove Injured',
    },
    generalRemoveInjuredPopupMessage: {
        id: 'twia.fnol.general.views.what.modal.Are you sure you want to remove Injured #{injuredIndex}?',
        defaultMessage:
            'Are you sure you want to remove Injured #{injuredIndex}?',
    },
    generalRemoveInjuredPopupRemoveButton: {
        id: 'twia.fnol.general.views.what.modal.Remove',
        defaultMessage: 'Remove',
    },
    generalDescribeWhatHappened: {
        id: 'twia.fnol.general.views.what.Describe what happened',
        defaultMessage: 'Describe what happened',
    },
    generalLossCause: {
        id: 'twia.fnol.general.views.what.Loss Cause',
        defaultMessage: 'Loss Cause',
    },
    generalSelectLossCause: {
        id: 'twia.fnol.general.views.what.Select Loss Cause',
        defaultMessage: 'Select Loss Cause',
    },
    generalIndicateWhoOrWhat: {
        id: 'twia.fnol.general.views.what.Indicate who or what caused the incident, and provide other details that would be helpful.',
        defaultMessage:
            'Indicate who or what caused the incident, and provide other details that would be helpful.',
    },
    generalDescribeDamage: {
        id: 'twia.fnol.general.views.what.Describe damage',
        defaultMessage: 'Describe damage',
    },
    generalListWhatWasDamaged: {
        id: 'twia.fnol.general.views.what.List what was damaged or lost during the incident, such as structural damage or office equipment.',
        defaultMessage:
            'List what was damaged or lost during the incident, such as structural damage or office equipment.',
    },
    generalDescribeInjuries: {
        id: 'twia.fnol.general.views.what.Describe injuries if any',
        defaultMessage: 'Describe injuries if any',
    },
    generalTypeOfIncidentDelete: {
        id: 'twia.fnol.wizard.tooltip.Delete',
        defaultMessage: 'Delete',
    },
    cancelTitle: {
        id: 'twia.fnol.common.config.FlowConfig.Are you sure you want to cancel?',
        defaultMessage: "Are you sure you want to cancel?"
    },
    cancelModalMessage: {
        id: 'twia.fnol.common.config.FlowConfig.The information you have entered will not be saved.',
        defaultMessage: 'The information previously entered may not be saved.',
    },
    saveAndExitModalTitle: {
        id: 'twia.fnol.common.config.FlowConfig.Save and Exit?',
        defaultMessage: 'Save and Exit?',
    },
    saveAndExitModalMessage: {
        id: 'twia.fnol.common.config.FlowConfig.We will save the information you have entered up to this point as a draft claim.',
        defaultMessage:
            'We will save the information you have entered up to this point as a draft claim.',
    },
    policyChangeModalTitle: {
        id: 'twia.fnol.common.controllers.PolicySelectPolicyholderCtrl.Modal Title',
        defaultMessage: 'Policy change',
    },
    policyChangeModalMessage: {
        id: 'twia.fnol.common.controllers.PolicySelectPolicyholderCtrl.Modal Content',
        defaultMessage:
            'You have selected a new policy for this claim. The data you have entered for this claim will be lost.',
    },
    noPolicyFoundMessage: {
        id: 'twia.fnol.common.views.policy-select-policyholder.No policies were found that match the search criteria.',
        defaultMessage:
            'No policies were found that match the search criteria.',
    },
    changePolicyButtonlabel: {
        id: 'twia.fnol.common.controllers.PolicySelectPolicyholderCtrl.Modal Option',
        defaultMessage: 'Change Policy',
    },
    fnolMessagePopupYes: {
        id: 'twia.fnol.common.config.FlowConfig.Yes',
        defaultMessage: 'Yes',
    },
    fnolMessagePopupCancel: {
        id: 'twia.fnol.common.config.FlowConfig.Cancel',
        defaultMessage: 'Cancel',
    },
    fnolUnnamed: {
        id: 'twia.fnol.common.model.Unnamed',
        defaultMessage: 'Unnamed',
    },
    fnolBackToHome: {
        id: 'twia.fnol.common.views.confirmation.Back to Homepage',
        defaultMessage: 'Back to Homepage',
    },
    fnolBackToClaims: {
        id: 'twia.fnol.common.views.confirmation.Back to claims',
        defaultMessage: 'Back to claims',
    },
    selectPolicyTitle: {
        "id": "fnol.wizard.steps.Date of Loss & Policy Verification",
        "defaultMessage": "Date of Loss & Policy Verification"
    },
    mainContactInformation: {
        "id": "fnol.wizard.step.Main Contact Information",
        "defaultMessage": "Main Contact Information"
    },
    lossdetails:{
        "id": "fnol.wizard.step.general.Loss Details",
        "defaultMessage": "Loss Details"
    },
    additionalLossDetails:{
        "id": "fnol.wizard.step.Additional Loss Details",
        "defaultMessage": "Additional Loss Details"
    },
    newClaimSteps: {
        id: 'twia.fnol.common.views.fnol.New Claim Steps',
        defaultMessage: 'New Claim Steps',
    },
    newClaimInformation: {
        id: 'twia.fnol.common.views.fnol.All of the steps to report a new claim must be completed during one internet session, including clicking \"Submit Claim\" on the final screen. If you leave the session before submitting your report, data will not be saved. The claim number is confirmation that your claim has been successfully reported.',
        defaultMessage: 'All of the steps to report a new claim must be completed during one internet session, including clicking \"Submit Claim\" on the final screen. If you leave the session before submitting your report, data will not be saved. The claim number is confirmation that your claim has been successfully reported.',
    },
    duplicateMessageInfo: {
        "id": "twia.fnol.common.views.fnol.Only one claim can be submitted at a time. To submit additional claims, please return to the Manage Claims screen after you complete this claim.",
        "defaultMessage": "Only one claim can be submitted at a time. To submit additional claims, please return to the Manage Claims screen after you complete this claim."
    },
    dateOfLossHeading: {
        "id": "twia.fnol.common.views.policy-select-policyholder.Date of Loss",
        "defaultMessage": "Date of Loss"
    },
    EmailValidationMessage: {
        id: 'twia.fnol.common.views.Must be a valid email address',
        defaultMessage: 'Must be a valid email address.',
    },
    required: {
        id: 'twia.fnol.common.views.required field',
        defaultMessage: 'This is a required field.',
    },
    phoneValidationMessage: {
        id: 'twia.fnol.common.views.Must be a valid 10-digit phone number',
        defaultMessage: 'Must be a valid 10-digit phone number.',
    },
    extraDamage: {
        id: "twia.fnol.ho.views.ho-fire-details.Is there any damage to the exterior of the home or other insured structures?",
        defaultMessage: "Is there any damage to the exterior of the home or other insured structures?"
    },
    extraCommercialDamage: {
        id: "twia.fnol.cp.views.cp-fire-details.Is there any damage to the exterior of the building or other insured structures?",
        defaultMessage: "Is there any damage to the exterior of the building or other insured structures?"
    },
    interiorDamage: {
        id: "twia.fnol.ho.views.ho-fire-details.Is there any damage to the interior of the home?",
        defaultMessage: "Is there any damage to the interior of the home?"
    },
    interiorCommericalDamage: {
        id: "twia.fnol.cp.views.cp-fire-details.Is there any damage to the interior of the building?",
        defaultMessage: "Is there any damage to the interior of the building?"
    },
    personalDamage: {
        id: "twia.fnol.ho.views.ho-fire-details.Is there any damage to personal property?",
        defaultMessage: "Is there any damage to personal property?"
    },
    commericalDamage: {
        id: "twia.fnol.cp.views.ho-fire-details.Is there any damage to business personal property?",
        defaultMessage: "Is there any damage to business personal property?"
    },
    homeUnavailable: {
        id: "twia.fnol.ho.views.ho-fire-details.Has the resulting damage made the home unlivable?",
        defaultMessage: "Has the resulting damage made the home unlivable?"
    },
    homeUnavailableCommercial: {
        id: "twia.fnol.cp.views.cp-fire-details.Has the damage resulted in the suspension of normal business operations?",
        defaultMessage: "Has the damage resulted in the suspension of normal business operations?"
    },
    commericalEmerServ: {
        id: "twia.fnol.cp.views.cp-fire-details.Are emergency services requested?",
        defaultMessage: "Are emergency services requested?"
    },
    additonalLossDetailsTitle: {
        id: "twia.fnol.ho.views.additional-loss-details.Additional Loss Details",
        defaultMessage: "Additional Loss Details"
    },
    fnolBackToAccountsPage: {
        id: 'twia.fnol.common.views.confirmation.Back to Accounts Page',
        defaultMessage: 'Back to Accounts Page'
    },
    fnolBackToPoliciesPage: {
        id: 'twia.fnol.common.views.confirmation.Back to Policies Page',
        defaultMessage: 'Back to Policies Page'
    },
    fnolBackToClaimsPage: {
        id: 'twia.fnol.common.views.confirmation.Back to Claims Page',
        defaultMessage: 'Back to Claims Page'
    },
    fnolBackToSummaryPage: {
        id: 'twia.fnol.common.views.confirmation.Back to Summary Page',
        defaultMessage: 'Back to Summary Page'
    },
    reviewInfoText: {
        id: 'fnol.common.views.confirmation.After editing your claim information, click the "Next" button to save your edits and navigate back to the "Summary" screen. Remember that if you leave the session and do not submit your report, the data will not be saved.',
        defaultMessage: 'After editing your claim information, click the "Next" button to save your edits and navigate back to the "Summary" screen. Remember that if you leave the session and do not submit your report, the data will not be saved.',
    },
    finalStepPara: {
        id: 'fnol.common.views.confirmation.Your final step will be to review the summary below to ensure it is accurate to the best of your knowledge before submitting your report to TWIA. Once you click "Submit Claim," you will receive a claim number to confirm that TWIA has received your report and opened the claim.',
        defaultMessage: 'Your final step will be to review the summary below to ensure it is accurate to the best of your knowledge before submitting your report to TWIA. Once you click "Submit Claim," you will receive a claim number to confirm that TWIA has received your report and opened the claim.',
    },
    finalStepParaTFPA:{
        id: 'fnol.common.views.confirmation.Your final step will be to review the summary below to ensure it is accurate to the best of your knowledge before submitting your report to TFPA. Once you click "Submit Claim," you will receive a claim number to confirm that TFPA has received your report and opened the claim.',
        defaultMessage: 'Your final step will be to review the summary below to ensure it is accurate to the best of your knowledge before submitting your report to TFPA. Once you click "Submit Claim," you will receive a claim number to confirm that TFPA has received your report and opened the claim.',
    },
    editClaimReportPrevious:{
        id: 'fnol.common.views.confirmation.Click "Previous" to navigate to previous screens until you reach the information you wish to edit.',
        defaultMessage: 'Click "Previous" to navigate to previous screens until you reach the information you wish to edit.',
    },
    editClaimReportSideMenu:{
        id: 'fnol.common.views.confirmation.Select a section you wish to edit in the navigation menu to the left.',
        defaultMessage: 'Select a section you wish to edit in the navigation menu to the left.',
    },
    editClaimReportHeader:{
        id: 'fnol.common.views.confirmation.There are two ways to edit your claim report:',
        defaultMessage: 'There are two ways to edit your claim report:',
    },
    whathappened: {
        id: 'twia.fnol.common.views.summary.What happened?',
        defaultMessage: 'What happened?',
    },
    causeOfDamge: {
        id: 'twia.fnol.common.views.summary.Cause of Damage or Loss',
        defaultMessage: 'Cause of Damage or Loss',
    },
    mailingAddress: {
        id: 'twia.fnol.common.directives.policy-search-result-detailed.Mailing Address',
        defaultMessage: 'Mailing Address'
    },
    lossLocationAddress: {
        id: 'twia.fnol.common.directives.policy-search-result-detailed.Loss Location address',
        defaultMessage: 'Loss Location address'
    },
    policyVerificationTitle: {
        id: 'twia.fnol.common.views.policy-select-policyholder-header.Policy Verification',
        defaultMessage: 'Policy Verification'
    },
    duplicateMessageInfoTFPA: {
        id: 'tfpa.fnol.common.views.fnol.Only one claim can be submitted at a time. To submit additional claims, please return to the account or policy page for the applicable policy and click on the Claims filter. Then, click "File a Claim".',
        defaultMessage: 'Only one claim can be submitted at a time. To submit additional claims, please return to the account or policy page for the applicable policy and click on the Claims filter. Then, click "File a Claim".'
    },
    contactPrefWarningMsgTWIA: {
        id: 'twia.fnol.common.views.Contact Preferences Warning TWIA',
        defaultMessage: 'Adding contacts does not grant TWIA permission to contact the additional named individual(s) directly. TWIA will contact policyholders for permission to discuss details of TWIA policy and claims with any third party.'
    },
    contactPrefWarningMsgTFPA: {
        id: 'tfpa.fnol.common.views.Contact Preferences Warning TFPA',
        defaultMessage: 'Adding contacts does not grant TFPA permission to contact the additional named individual(s) directly. TFPA will contact policyholders for permission to discuss details of TFPA policy and claims with any third party.'
    },
    mailingAddressBannerText: {
        id: 'tfpa.fnol.common.views.mailing-address-banner.International and U.S. territory addresses cannot be used as mailing addresses to submit a claim through the portal. Please call (800) 979-6440 to file a claim.',
        defaultMessage: 'International and U.S. territory addresses cannot be used as mailing addresses to submit a claim through the portal. Please call (800) 979-6440 to file a claim.'
    },
    relatedPolicy: {
        id: 'twia.fnol.common.views.policy-select-policyholder.Which policy is this related to ?',
        defaultMessage: 'Which policy is this related to ?',
    },
    twiaCallCenterText: {
        id: 'twia.fnol.info.call.TWIA Call-center',
        defaultMessage: 'Have questions or need assistance? Contact us 24 hours a day at (800) 788-8247.'
    },
    tfpaCallCenterText: {
        id: 'tfpa.fnol.info.call.TFPA Call-center',
        defaultMessage: 'Have questions or need assistance? Contact us 24 hours a day at (800) 979-6440.'
    },
    twiaConfirmMsg: {
        id: 'twia.fnol.info.call.TwiaConfirmMsg',
        defaultMessage: 'From the Claims tab, you can access claim status, submit documents, and communicate with TWIA representatives assigned to this claim.'
    },
    tfpaConfirmMsg: {
        id: 'tfpa.fnol.info.call.TfpaConfirmMsg',
        defaultMessage: 'From the Claims tab, you can access claim status, submit documents, and communicate with TFPA representatives assigned to this claim.'
    },
    twiaSubmitInfoMsg: {
        id: 'twia.fnol.info.call.twiaSubmitInfoMsg',
        defaultMessage: 'Moving forward, you can access this claim when you log in to Producer Engage.'
    },
    tfpaSubmitInfoMsg: {
        id: 'tfpa.fnol.info.call.tfpaSubmitInfoMsg',
        defaultMessage: 'Moving forward, you can manage this claim when you log in to Agent Gateway.'
    },
    additionalInfoTextCETwia: {
        id: 'fnol.common.views.confirmation.When contacting your agent or TWIA about your claim, have this number available for faster service. You can access and manage your claim right here. From the Claims page, you can submit additional documents,  communicate with TWIA representatives assigned to this claim, and review claim details.',
        defaultMessage: 'When contacting your agent or TWIA about your claim, have this number available for faster service. You can access and manage your claim right here. From the Claims page, you can submit additional documents, communicate with TWIA representatives assigned to this claim, and review claim details.'
    },
    additionalInfoTextCETfpa: {
        id: 'fnol.common.views.confirmation.When contacting your agent or TFPA about your claim, have this number available for faster service. You can access and manage your claim right here. From the Claims page, you can submit additional documents,  communicate with TFPA representatives assigned to this claim, and review claim details.',
        defaultMessage: 'When contacting your agent or TFPA about your claim, have this number available for faster service. You can access and manage your claim right here. From the Claims page, you can submit additional documents, communicate with TFPA representatives assigned to this claim, and review claim details.'
    },
    additionalInfoSubTextCETfpa: {
        id: 'fnol.common.views.confirmation.You can also submit additional claims on the main page.',
        defaultMessage: 'You can also submit additional claims on the main page.'
    },
    tfpaContactPreference: {
        id: 'fnol.common.views.confirmation.tfpaContactPreference',
        defaultMessage: 'By choosing the option for the policyholder/main contact to receive documents by email or through Claims Center, you acknowledge and agree on the policyholder/main contact\'s behalf that the policyholder will only receive documents related to the claim via electronic delivery and will not receive hard copies of those documents through the mail. This consent applies only to this claim. If you and/or the policyholder file other claims, the policyholder may choose the same or a different means of delivery for documents related to those claims. You and/or the policyholder may change the preferred means of delivery, the designated email address, or request a hard copy of any particular document, at any time by calling us at (800) 979-6440. If you or the policyholder change the default means of delivery, the policyholder will receive any future document deliveries by the new method, but any documents previously delivered to the policyholder will not be re-sent.'
    },
    twiaContactPreference: {
        id: 'fnol.common.views.confirmation.twiaContactPreference',
        defaultMessage: 'By choosing the option for the policyholder/main contact to receive documents by email or through Claims Center, you acknowledge and agree on the policyholder/main contact\'s behalf that the policyholder will only receive documents related to the claim via electronic delivery and will not receive hard copies of those documents through the mail. This consent applies only to this claim. If you and/or the policyholder file other claims, the policyholder may choose the same or a different means of delivery for documents related to those claims. You and/or the policyholder may change the preferred means of delivery, the designated email address, or request a hard copy of any particular document, at any time by calling us at (800) 788-8247. If you or the policyholder change the default means of delivery, the policyholder will receive any future document deliveries by the new method, but any documents previously delivered to the policyholder will not be re-sent.'
    }
});
